import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ItemListResponse, Label } from '@models';
import { HttpParams, httpResource } from '@angular/common/http';
import { environment } from '@environment';
import { ListComponent } from '@components/list/list.component';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-label-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  imports: [
    ListComponent,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatPaginatorModule,
    RouterModule,
  ],
})
export class LabelListComponent {
  router = inject(Router);
  route = inject(ActivatedRoute);

  labels = httpResource<ItemListResponse<Label>>(() => {
    let httpParams = new HttpParams()
      .set('skip', this.page() * this.pageSize())
      .set('take', this.pageSize())
      .set('count', true);
    if (this.q()) {
      httpParams = httpParams.set('q', this.q());
    }
    return `${environment.kinkoHost}/label/?${httpParams}`;
  });

  q = signal<string>(this.route.snapshot.queryParams['q'] || '');
  page = signal(parseInt(this.route.snapshot.queryParams['page']) || 0);
  pageSize = signal(
    parseInt(this.route.snapshot.queryParams['pageSize']) || 10,
  );

  constructor() {
    this.route.queryParams.subscribe((params: Params) => {
      this.page.set(params['page'] || 0);
      this.pageSize.set(params['pageSize'] || 10);
      this.q.set(params['q'] || '');
    });
  }

  onPageEvent(event: PageEvent) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
      queryParams: {
        page: event.pageIndex || undefined,
        pageSize: event.pageSize === 10 ? undefined : event.pageSize,
      },
      replaceUrl: true,
    });
  }

  onSearchEvent(event: Event) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
      queryParams: {
        q: (event.target as HTMLInputElement).value || undefined,
        page: undefined,
      },
      replaceUrl: true,
    });
  }
}
